module.exports = ".btn.cancel, .btn.delete {\n  margin-bottom: 15px;\n  width: 85%; }\n\n.flash-element {\n  width: auto;\n  font-size: 90%;\n  margin: 0;\n  padding: 0 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-products/admin-product-edit/ape-unit-info/ape-unit-info.component.scss
// module id = ./src/app/components/admin/admin-products/admin-product-edit/ape-unit-info/ape-unit-info.component.scss
// module chunks = main